module.exports = __webpack_public_path__ + "static/media/flower_left.13c74eb4.png";